// The side the person at this screen plays. Alone it is Sun, and the AI plays
// Moon. In a room it is the side of the seat, and it can change at the start
// of each match. A spectator watches with no side to act for.
// It was the constant `PLAYER_SIDE` until 2026-10-13. Garrett asked for a room
// that two people play from two screens.

import type { Side } from '../engine/types';
import { createStore } from '../lib/store';

export const localSideStore = createStore<Side>('gold');

/** True while the screen only watches: a third person in a room. */
export const spectatingStore = createStore<boolean>(false);

export const localSide = (): Side => localSideStore.get();

/** True when the person at this screen may act for `side`. */
export const actsFor = (side: Side): boolean => !spectatingStore.get() && side === localSide();

/** The board turns so the side of this screen is at the bottom. */
export const isBoardFlipped = (): boolean => localSideStore.get() === 'violet';
